import { FETCH_DETAILS_REQUESTED } from "./actions";
import { DETAILS_LOADED } from "./actions";
import { DETAILS_ERROR } from "./actions";

const defaultState = {
  movieDetails: [],
  loading: true,
  error: null
};

export const detailsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_DETAILS_REQUESTED:
      return {
        movieDetails: [],
        loading: true,
        error: null
      };

    case DETAILS_LOADED:
      return {
        movieDetails: action.payload,
        loading: false,
        error: null
      };

    case DETAILS_ERROR:
      return {
        movieDetails: [],
        loading: false,
        error: true
      };

    default:
      return state;
  }
};
